import {
  DateFormats,
  formatISODate,
  Icon,
  type IsoDate,
  Tooltip,
  Typography,
  useViewport,
  Viewport,
} from '@omnipresentgroup/design-system';
import {
  InvoiceReportNetSuiteType,
  InvoiceReportStatus,
  InvoiceReportType,
} from '@omnipresentgroup/types';

import { isOverdueDate } from '../utils';

type Props = {
  dueDate: IsoDate;
  status: InvoiceReportStatus;
  invoiceType?: InvoiceReportType;
  invoiceTransactionType?: InvoiceReportNetSuiteType;
};

export const DueDateCell = ({
  dueDate,
  status,
  invoiceType,
  invoiceTransactionType,
}: Props) => {
  const viewport = useViewport();
  const isSmallDevices = viewport.isPhone || viewport.isTablet;

  const isOverdue = isOverdueDate(dueDate);
  const textIntent =
    status === InvoiceReportStatus.OPEN && isOverdue ? 'negative' : 'default';
  const showTooltip =
    !isSmallDevices &&
    invoiceType === InvoiceReportType.DEPOSIT &&
    invoiceTransactionType === InvoiceReportNetSuiteType.INVOICE;

  const formattedDueDate = formatISODate(dueDate, DateFormats.Date, false, '-');
  return (
    <>
      {!showTooltip && (
        <>
          <Viewport devices={['laptop', 'desktop', 'highRes']}>
            <Typography
              as="p"
              id="inv-due-date"
              size="14"
              color={textIntent}
              hideParagraphSpacing
            >
              {formattedDueDate}
            </Typography>
          </Viewport>
          <Viewport devices={['phone', 'tablet']}>
            <Typography
              as="p"
              id="inv-due-date"
              size="12"
              color={textIntent}
              hideParagraphSpacing
            >
              {formattedDueDate}
            </Typography>
          </Viewport>
        </>
      )}
      {showTooltip && (
        <Tooltip
          id="due-date-tooltip"
          description="Due before employment contract"
        >
          <Icon icon="HelpCircle" title="HelpCircle icon" size="16" />
        </Tooltip>
      )}
    </>
  );
};
